import React, { useEffect, useState } from "react";
import Countdown from "react-countdown";
import Button from "./Button";
import { useStakingContext } from "../context/staking-context";
import { useNavigate } from "react-router-dom";

const CountDownTimer = ({
  startTime,
  coolDownPeriod,
  validatorContractaddress,
  claimed,
}) => {
  const {
    isClaimed,
    isTrxHistoryBtnLoading,
    setSelectedValidator,
    userDelegators
  } = useStakingContext();
  const startTimeInMs = startTime * 1000;
  const [isProcessing, setIsProcessing] = useState(false);
  const navigate = useNavigate();

  const targetTime = startTimeInMs + coolDownPeriod * 24 * 60 * 60 * 1000;

  const handleClaimBtn = async () => {
    const currentDelegatorValidatorData = userDelegators?.find((data)=>data.id === validatorContractaddress)

      const obj = {
        name:currentDelegatorValidatorData?.name,
        performance:currentDelegatorValidatorData?.performance ?? 0,
        commission:currentDelegatorValidatorData?.commission ?? 0,
        contract_address:validatorContractaddress
    }
    localStorage?.setItem("selectedValidator", JSON.stringify(obj));
    setSelectedValidator(obj)

    navigate("/my-account/claim-unstake");
  };

  // Renderer function to customize the display of the countdown
  const renderer = ({ days, hours, minutes, completed, seconds }) => {

    if (completed) {
      return (
        <Button
          className={`primary-gradient py-3 px-[14px] leading-none ${isTrxHistoryBtnLoading || isClaimed || claimed
              ? "!opacity-50 !cursor-not-allowed"
              : ""
            }`}
          onClick={handleClaimBtn}
          disabled={isTrxHistoryBtnLoading || isClaimed || claimed}
        >
          {isProcessing
            ? "Processing"
            : isClaimed || claimed
              ? "Unstaked"
              : "Claim Now"}
        </Button>
      );
    } else {
      // Display the countdown
      return (
        <Button
          className="bg-primaryWhite/[0.08] text-primaryWhite/[0.50] !text-sm !font-normal py-3 px-[14px] leading-none min-w-[180px]"
        >
          <div className="min-w-[130px]">
          {days}d {hours}h {minutes}m {seconds}s
          </div>
        </Button>
      );
    }
  };

  useEffect(() => {
    if (isClaimed) {
      setIsProcessing(false);
    }
  }, [isClaimed]);

  return (
      <Countdown date={targetTime} renderer={renderer} />
  );
};

export default CountDownTimer;
